import { IconMenu2 } from '@tabler/icons-react';

import {
  BurgerMenuButtonIconWrapperStyled,
  BurgerMenuButtonStyled,
} from './styled';
import { BurgerMenuButtonType } from './types';

export const BurgerMenuButton: BurgerMenuButtonType = (props) => {
  const { onClick } = props;

  return (
    <BurgerMenuButtonStyled
      disableRipple //
      disableTouchRipple
    >
      <BurgerMenuButtonIconWrapperStyled //
        component="span"
        onClick={onClick}
      >
        <IconMenu2 stroke={1.5} size={21} />
      </BurgerMenuButtonIconWrapperStyled>
    </BurgerMenuButtonStyled>
  );
};
